// extracted by mini-css-extract-plugin
export var BtnV2 = "variant2-module--BtnV2--a6de1";
export var BtnV2Black = "variant2-module--BtnV2--black--e8072";
export var BtnV2Borderless = "variant2-module--BtnV2--borderless--50f87";
export var BtnV2Cloud = "variant2-module--BtnV2--cloud--87303";
export var BtnV2Disabled = "variant2-module--BtnV2--disabled--f949e";
export var BtnV2Focusable = "variant2-module--BtnV2--focusable--d9aea";
export var BtnV2Fullwidth = "variant2-module--BtnV2--fullwidth--ea15f";
export var BtnV2Gold = "variant2-module--BtnV2--gold--22d13";
export var BtnV2Grey = "variant2-module--BtnV2--grey--35539";
export var BtnV2Icon = "variant2-module--BtnV2--icon--b21f9";
export var BtnV2Lg = "variant2-module--BtnV2--lg--7383f";
export var BtnV2Midnight = "variant2-module--BtnV2--midnight--2193a";
export var BtnV2Multiline = "variant2-module--BtnV2--multiline--7e9c5";
export var BtnV2Nofocus = "variant2-module--BtnV2--nofocus--d1e1a";
export var BtnV2Secondary = "variant2-module--BtnV2--secondary--1bad6";
export var BtnV2Sm = "variant2-module--BtnV2--sm--7c47c";
export var BtnV2Solid = "variant2-module--BtnV2--solid--6e4ba";
export var BtnV2Square = "variant2-module--BtnV2--square--f3072";
export var BtnV2Success = "variant2-module--BtnV2--success--27db8";
export var BtnV2Text = "variant2-module--BtnV2--text--e0618";
export var BtnV2Warning = "variant2-module--BtnV2--warning--d0b94";
export var BtnV2White = "variant2-module--BtnV2--white--a6096";
export var BtnV2Xl = "variant2-module--BtnV2--xl--80954";
export var BtnV2Yellow = "variant2-module--BtnV2--yellow--f59a2";
export var ColorBlock = "variant2-module--ColorBlock--d7658";
export var ColorBlockColorGrey = "variant2-module--ColorBlock--colorGrey--8b685";
export var ColorBlockGrey = "variant2-module--ColorBlock--grey--9b484";
export var ColorBlockMidGrey = "variant2-module--ColorBlock--midGrey--a11f7";
export var ColorBlockPink = "variant2-module--ColorBlock--pink--4900a";
export var ColorBlockPrimary = "variant2-module--ColorBlock--primary--f80b6";
export var ColorBlockPrimaryDark = "variant2-module--ColorBlock--primaryDark--a50ec";
export var ColorBlockPrimaryLight = "variant2-module--ColorBlock--primaryLight--f980c";
export var ColorBlockPrimaryMid = "variant2-module--ColorBlock--primaryMid--18a86";
export var ColorBlockPurple = "variant2-module--ColorBlock--purple--bf293";
export var ColorBlockRed = "variant2-module--ColorBlock--red--a1985";
export var ColorBlockSecondary = "variant2-module--ColorBlock--secondary--f0525";
export var ColorBlockSecondaryDark = "variant2-module--ColorBlock--secondaryDark--366d1";
export var ColorBlockSecondaryLight = "variant2-module--ColorBlock--secondaryLight--03fa4";
export var ColorBlockSecondaryMid = "variant2-module--ColorBlock--secondaryMid--5930e";
export var ColorBlockText = "variant2-module--ColorBlock--text--249c4";
export var ColorBlockYellow = "variant2-module--ColorBlock--yellow--a14ed";
export var ColorBlocks = "variant2-module--ColorBlocks--3da4f";
export var DashboardTopoptions = "variant2-module--Dashboard--topoptions--85b59";
export var HideEmbedded = "variant2-module--HideEmbedded--6fe42";
export var ShowEmbedded = "variant2-module--ShowEmbedded--ba181";
export var Template__descriptionContent = "variant2-module--Template__description-content--1c467";
export var __active = "variant2-module--__active--cd166";
export var __custom = "variant2-module--__custom--6b642";
export var _pin = "variant2-module--_pin--838bc";
export var _pinText = "variant2-module--_pinText--7a0f3";
export var aliceCarousel__dots = "variant2-module--alice-carousel__dots--dcada";
export var aliceCarousel__dotsItem = "variant2-module--alice-carousel__dots-item--6f987";
export var bottomCTA = "variant2-module--bottomCTA--4189f";
export var bottomCTAColumns = "variant2-module--bottomCTAColumns--e6e33";
export var bottomCTAInner = "variant2-module--bottomCTAInner--bf4f8";
export var btnGroup = "variant2-module--btn-group--ae185";
export var calculationsBlock = "variant2-module--calculationsBlock--1bc11";
export var caseStudiesBlock = "variant2-module--caseStudiesBlock--84069";
export var ccCompliance = "variant2-module--cc-compliance--a0ff4";
export var cta = "variant2-module--cta--563dd";
export var customerCTA = "variant2-module--customerCTA--e438e";
export var customerQuoteGrid = "variant2-module--customerQuoteGrid--43db6";
export var fadeIn = "variant2-module--fadeIn--32c37";
export var formSection = "variant2-module--formSection--39b04";
export var formSectionContent = "variant2-module--formSectionContent--86f88";
export var formSectionForm = "variant2-module--formSectionForm--f9066";
export var forms = "variant2-module--forms--8c6a7";
export var getStartedForm = "variant2-module--getStartedForm--6ec62";
export var h1 = "variant2-module--h1--72331";
export var h1S = "variant2-module--h1S--df808";
export var h2 = "variant2-module--h2--6bf4c";
export var h3 = "variant2-module--h3--c9b8c";
export var h4 = "variant2-module--h4--0daa7";
export var hero = "variant2-module--hero--ff37a";
export var heroCTA = "variant2-module--heroCTA--0efbe";
export var heroContent = "variant2-module--heroContent--63da0";
export var heroVideo = "variant2-module--heroVideo--05ea1";
export var inspirationBlock = "variant2-module--inspirationBlock--e8dc4";
export var inspirationCard = "variant2-module--inspirationCard--cbf7c";
export var inspirationCard1 = "variant2-module--inspirationCard1--ec1a3";
export var inspirationCard2 = "variant2-module--inspirationCard2--31f67";
export var inspirationCard3 = "variant2-module--inspirationCard3--df32a";
export var inspirationCard4 = "variant2-module--inspirationCard4--508aa";
export var inspirationCard5 = "variant2-module--inspirationCard5--5b790";
export var inspirationCard6 = "variant2-module--inspirationCard6--15deb";
export var inspirationCard7 = "variant2-module--inspirationCard7--f4a97";
export var inspirationCardTitle = "variant2-module--inspirationCardTitle--1b368";
export var inspirationCardWrapper = "variant2-module--inspirationCardWrapper--7ddc4";
export var liAnim = "variant2-module--liAnim--b9ce1";
export var link = "variant2-module--link--4be3a";
export var maxWidth = "variant2-module--max-width--43c7b";
export var menuOpen = "variant2-module--menu-open--08897";
export var noChildPMb = "variant2-module--no-child-p-mb--480c6";
export var nobar = "variant2-module--nobar--61942";
export var pin = "variant2-module--pin--dad57";
export var productBlock = "variant2-module--productBlock--6d906";
export var rating = "variant2-module--rating--bb41b";
export var seogroup = "variant2-module--seogroup--8a140";
export var signupBlock = "variant2-module--signupBlock--80c3a";
export var svgAnim = "variant2-module--svgAnim--d6b45";
export var svgDraw = "variant2-module--svgDraw--b0706";
export var takeoverAboveFoldActive = "variant2-module--takeoverAboveFoldActive--03d20";
export var takeoverHero = "variant2-module--takeoverHero--0bebf";
export var takeoverMore = "variant2-module--takeoverMore--fb936";
export var verifiedBlock = "variant2-module--verifiedBlock--40380";
export var video = "variant2-module--video--1b977";
export var videoEnd = "variant2-module--videoEnd--3a2cf";
export var videoStart = "variant2-module--videoStart--dd992";
export var videoWrapper = "variant2-module--videoWrapper--c4cda";